import {
    RESET_MEDIA,
    GET_SWING_VIDEO_USER_SAS,
    GET_SWING_VIDEO_USER_SAS_SUCCESS,
    GET_SWING_VIDEO_USER_SAS_ERROR
} from '../constants/ActionTypes';

const INIT_MEDIA_STATE = {
    swingVideoUserSas: null,
    swingVideoUserSasLoader: false,
    swingVideoUserSasError: null
}

export default (state = INIT_MEDIA_STATE, action) => {
    switch (action.type) {
        case RESET_MEDIA: {
            return {
                ...INIT_MEDIA_STATE
            }
        }
        case GET_SWING_VIDEO_USER_SAS: {
            const res = {
                playerUid: action.payload.playerUid
            }
            return {
                ...state,
                swingVideoUserSasLoader: true,
                swingVideoUserSas: res
            }
        }
        case GET_SWING_VIDEO_USER_SAS_SUCCESS: {

            var res = state.swingVideoUserSas
            res.containerUrl = action.payload.containerUrl
            res.sas = action.payload.sas
            res.sasExpiry = new Date().getTime() + 3600000
            return {
                ...state,
                swingVideoUserSas: res,
                swingVideoUserSasLoader: false,
                swingVideoUserSasError: null
            }
        }
        case GET_SWING_VIDEO_USER_SAS_ERROR: {
            return {
                ...state,
                swingVideoUserSasError: action.payload,
                swingVideoUserSasLoader: false
            }
        }
        default:
            return state;
    }
}